import type { IconData } from '@stacksjs/iconify-core'

export const envelopeOpen: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m2.328 6.868l7.017 6.253a1 1 0 0 0 1.33 0l7.009-6.246l-7.137-4.665a1 1 0 0 0-1.094 0zM18 7.082v2.19l-5.994 5.342a3 3 0 0 1-3.992 0L2 9.254V7.083V18h16zM.906 5.408L8.359.536a3 3 0 0 1 3.282 0l7.453 4.872A2 2 0 0 1 20 7.082V18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7.082a2 2 0 0 1 .906-1.674\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default envelopeOpen
